import axios from "axios";
import router from "@/router";
import Element from "element-ui"
import authToken from '@/utils/auth'
import qs from 'qs';

import { message } from '@/utils/resetMessage'



// const urls = {
// 	baseURL:"http://192.168.111.222:8811",
// 	webURL:"http://192.168.111.222:8001"
// }

// const urls = {
// 	baseURL:"http://192.168.111.6:8811",
// 	webURL:"http://bolian.88993377.cn:85"
// }
// const urls = {
// 	baseURL:"http://bolianapi.88993377.cn:85",
// 	webURL:"http://bolian.88993377.cn:85"
// }
const urls = {
	//本地
	// baseURL:"http://192.168.111.222:8811",
	// webURL:"http://www.union-file.cn"
	//博联云地服务器
	//baseURL:"http://192.168.111.222:8811",
    baseURL:"http://api.union-file.cn",
	webURL:"http://www.union-file.cn"
	
	
	//博联本地服务器
	//baseURL:"http://192.168.0.10:8811",
	//webURL:"http://192.168.0.10:8080",
	
}

if(process.env.NODE_ENV=="development"){
	urls.baseURL="http://192.168.111.222:8811"
	urls.webURL="http://www.union-file.cn"
	//baseURL:"http://api.union-file.cn"
}

//请求地址
axios.defaults.baseURL = urls.baseURL;

/**
 * 默认请求
 */
const request = axios.create({
	timeout: 2*60*1000,
	headers: {
		'Content-Type': "application/x-www-form-urlencoded;charset=utf-8"
	}
})
/**
 * 请求
 */
request.interceptors.request.use(config => {
	var token = authToken.getToken()
	if(token!=undefined && token!=null && token.length>0){
		config.headers['Authorization'] ='Bearer '+token
	}
	return config
})
/**
 * 响应
 */
request.interceptors.response.use(
	response => {
		
		//如果响应头部存在身份验证信息，则更新token
		let Authorization = response.headers["Authorization"];
		
		if(Authorization!=undefined && Authorization !=null && Authorization!=""){
			authToken.setToken(Authorization);
		}
		
		let res = response.data
		var  contenttype = response.headers["content-type"];
		
		
		if(res.code &&(res.code=="1" || res.code ==1)){
			message.error(!res.msg ? '系统异常' : res.msg)
		}
		return res
		// if(Array.isArray(res) || typeof res == Object){
		// 	if (res.code === 0) {
		// 		return res;
		// 	} else {
		// 		message.error(!res.msg ? '系统异常' : res.msg)
		// 		return res
		// 	}
		// }else{
		// 	return res
		// }
				
		// if(contenttype=='multipart/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' || contenttype== 'application/octet-stream' || contenttype== 'application/pdf;charset=UTF-8' ||  contenttype== 'application/vnd.ms-excel;charset=utf-8' ){
		// 	return res;
		// }else{
		// 	if (res.code === 0) {
		// 		return res;
		// 	} else {
		// 		message.error(!res.msg ? '系统异常' : res.msg)
		// 		return res
		// 	}
		// }
		
	},
	error => {
		//console.log(error)
		// if (error.response.data) {
		// 	error.massage = error.response.data.msg
		// }
		
		if (error.response.status === 401) {
			message.error("登录状态已失效", {duration: 3000})
			router.push("/login")
		}
		else if (error.response.status === 500) {
			message.error("系统错误,错误码:"+error.response.status);
		}
		
		return Promise.reject(error)
	}
)

/**
 * 全部暴露
 */
export default {
	
	post(url,data={}){
		data = qs.stringify(data)
		return request.post(url,data)
	},
	get(url,data={}){
		return request({
			url:url,
			methods:"get",
			params:data
		})
	},
	upload(url,data={}){
		return request.post(url,data,{timeout: 120*60*1000})
	},
	download(url,data={}){
		data = qs.stringify(data)
		return request.post(url,data,{
			responseType: 'blob'
		})
	},
	baseUrl(){
		return axios.defaults.baseURL
	},
	webUrl(){
		return urls.webURL
	}
	
}